import { withFeature } from "@packages/core/access/featureAccess.ts";
import { PERFORMANCE_CYCLE_DETAILS_ACCESS } from "@packages/core/access/settingsAccess.ts";
import type { Role } from "@packages/core/session/roles.ts";
import { cycleReviewAreaSegment, type CycleDetailOrigin } from "@domains/reviews/client/components/cycles/cycleDetailPaths.ts";
import { cycleReviewVertical, type ReviewVertical } from "@domains/reviews/client/components/reviewRoutes.ts";

export interface PeopleReviewPlacement {
    kind: "people";
}

export interface CycleReviewPlacement {
    kind: "cycle";
    origin: CycleDetailOrigin;
}

export type ReviewPlacement = PeopleReviewPlacement | CycleReviewPlacement;

export const PEOPLE_REVIEW_PLACEMENT: PeopleReviewPlacement = { kind: "people" };

export interface ResolvedReviewPlacement {
    basePath: string;
    access: Role[];
    areaIdPrefix: string;
    pageHandlePrefix: string;
    vertical: ReviewVertical;
}

export function resolveReviewPlacement(placement: ReviewPlacement): ResolvedReviewPlacement {
    if (placement.kind === "people") {
        return {
            basePath: "/org/people/:personId/reviews/:cycleId",
            access: withFeature("PerformanceReviews"),
            areaIdPrefix: "person-review",
            pageHandlePrefix: "DirectoryProfileReview",
            vertical: "org/people"
        };
    }

    const { origin } = placement;

    return {
        basePath: cycleReviewAreaSegment(origin),
        access: withFeature("PerformanceReviews", PERFORMANCE_CYCLE_DETAILS_ACCESS),
        areaIdPrefix: `cycle-review-${origin}`,
        pageHandlePrefix: "ReviewCycleReview",
        vertical: cycleReviewVertical(origin)
    };
}
